import React from 'react'
import CardHeader from '../../../components/shared/card/card-header'
import root from '../utils'

const Card = ({isJobActivity, btnId, index, headerHidden, additionalClasses, padding, cardBottomPadding, cardSmallHeaderImage, cardSmallHeaderIcon,customHeaderStyle, tempHeight, close, imageHeight, cardClass, btnText, smallBtnText, btnStyle, headerTitle, headerSubtitle, heroImage, headerLeftIcon, textMidIcon, headerRightIcon, headerMidIcon, textColorHex, backgroundColorHex, border, topBarIcon, topBarText, topBarColor, borderColor, moduleType, btnOnClick, noPullDown, children}, context) => {
  let cardType, topBarComp, buttonC
  let leftChevron = root + '/common/latest/images/consumer/right-chev.png'

  if (cardClass) {
    cardType = ' card-inverse ' + cardClass
  } else {
    cardType = ' '
  }

  if (btnText) {
    buttonC = []

    if (smallBtnText !== undefined) {
      buttonC.push(<button id={btnId} key={'btn'} className={btnStyle + ' center-block visible-sm hidden-xs'} onClick={btnOnClick}>{smallBtnText}</button>)
      btnStyle += ' hidden-sm'
    }
    buttonC.push(<button id={btnId} key={'center'} className={btnStyle + ' center-block'} onClick={btnOnClick}>{btnText}</button>)
  }

  let borderStyle = {
    borderColor: borderColor,
    backgroundColor: backgroundColorHex,
    color: textColorHex
  }
  let cardPadding 
  if(cardBottomPadding){
      cardPadding = {
      paddingBottom: cardBottomPadding
    }
  }
  if(padding){
    cardPadding = {
      paddingLeft: padding,
      paddingRight: padding,
      paddingBottom: padding
    }
  }

  let borderBlock
  let closeMe
  let chevron = []

  if (border) {
    if (border === 'left') {
      borderBlock = 'border-left'
      let rightChevron = root + '/common/latest/images/consumer/left-chev.png'
      chevron.push(<img key='right' alt='right chevron' src={rightChevron} className='right-chevron hidden-xs' />)
      chevron.push(<img key='left' alt='left chevron' src={leftChevron} className='left-chevron visible-xs-block' />)
    } else {
      borderBlock = 'border-right'
      chevron.push(<img key='left' src={leftChevron} alt='left chevron' className='left-chevron' />)
    }
  }
  if (topBarIcon) {
    if (close) {
      closeMe = <button style={{marginRight: 10}} className='close hidden-md hidden-lg' onClick={close}><span>&times;</span></button>
    }
    topBarComp = <div className={topBarColor} style={{margin: '-12px -30px 20px -30px', padding: '10px 0px 10px 0px'}}>
      {closeMe}
      <img src={topBarIcon} alt='top bar' className='img-responsive center-block' />
      <h6 className='text-center' style={{fontWeight: '300', color: 'white'}}>{topBarText}</h6>
    </div>
  }

  let smallHeader, smallHeaderIcon;
  let newCardImage = root + '/styleguide/assets/img/task-backgrounds/' + cardSmallHeaderImage

  
  if(cardSmallHeaderImage){
    smallHeaderIcon = <div className='primary-card-icon task-type small no-text'>
                        <div style={{height: 50, width: 50}} role='presentation' className={`img-responsive center-block ${cardSmallHeaderIcon}-circle`}/>
                      </div>  

    smallHeader = <div className='small-header'>
                  <img className='small-header-image'src={newCardImage} alt=''/>
                  {smallHeaderIcon}
                </div>
  }

  let pullDownClass = noPullDown ? '' : 'pull-down-xs-2'

  if (!cardType) cardType = ''
  if (!borderBlock) borderBlock = ''
  if (!additionalClasses) additionalClasses = ''
  let head
  if (!headerHidden) {
    head = <CardHeader
      isJobActivity={isJobActivity}
      imageHeight={imageHeight}
      headerTitle={headerTitle}
      headerSubtitle={headerSubtitle}
      cardClass={cardClass}
      imgPadding={padding}
      heroImage={heroImage}
      headerLeftIcon={headerLeftIcon}
      headerMidIcon={headerMidIcon}
      headerRightIcon={headerRightIcon}
      textMidIcon={textMidIcon}
      customHeaderStyle={customHeaderStyle} />
  }
  return (
    <div>
      <div className={'card ' + pullDownClass + ' ' + cardType + ' ' + borderBlock + ' ' + additionalClasses} style={{...borderStyle, ...cardPadding}}>
        {topBarComp}
        {smallHeader}
        {head}
        {chevron}
        <div style={{height: tempHeight}}>
          {children}
        </div>
        <div>
          {buttonC}
        </div>
      </div>
    </div>
  )
}

Card.propTypes = {
  additionalClasses: React.PropTypes.string,
  textColorHex: React.PropTypes.string,
  backgroundColorHex: React.PropTypes.string,
  cardClass: React.PropTypes.string,
  btnText: React.PropTypes.string,
  button: React.PropTypes.bool,
  btnStyle: React.PropTypes.string,
  headerTitle: React.PropTypes.string,
  headerSubtitle: React.PropTypes.string,
  heroImage: React.PropTypes.string,
  textMidIcon: React.PropTypes.string,
  headerLeftIcon: React.PropTypes.string,
  headerRightIcon: React.PropTypes.string,
  headerMidIcon: React.PropTypes.string,
  btnOnClick: React.PropTypes.func,
  topBarIcon: React.PropTypes.string,
  topBarText: React.PropTypes.string,
  noPullDown: React.PropTypes.bool,
  children: React.PropTypes.oneOfType([
    React.PropTypes.array,
    React.PropTypes.element
  ])
}

export default Card



// WEBPACK FOOTER //
// ./src/components/shared/card/card.jsx